import { Schema } from '@core/data/dto/schema';
import { FORMAT } from '@core/utils/formats';
import moment from 'moment';
import { EmployeeProviderMetadata } from './employee-provider-metadata';

export const EmployeeProviderDataSchema = {
    id: Schema.String,
    active: Schema.Boolean,
    company: Schema.String,
    defaultNetPaySplit: Schema.String,
    dob: {
        map: 'dob',
        mapImport: (value: string) =>
            moment(value, FORMAT.DATE_SHORT),
    },
    email: Schema.String,
    firstName: Schema.String,
    lastName: Schema.String,
    metadata: EmployeeProviderMetadata,
    paymentMethodPreference: Schema.Auto,
    primaryWorkplace: Schema.String,
    ssnLastFour: Schema.String,
    ssnValidationStatus: Schema.Auto,
    startDate: {
        map: 'startDate',
        mapImport: (value: string) =>
            moment(value, FORMAT.DATE_SHORT),
    },
    w2ElectronicConsentProvided: Schema.Boolean,
    workplaces: Schema.Auto
}
